import {RouterModule, Routes}                   from '@angular/router';
import {SchemasComponent}                                          from './schemas.component';
import {AuthenticationService}       from '../shared/authentication.service';
import {BaseResolver, BasesResolver} from '../shared/resolvers/bases.resolver';
import {Base}                        from '../shared/api/bases/api.models';
import {AddSchemaComponent}          from './add.component';
import {EditSchemaComponent}         from './edit.component';
import {CopySchemaComponent}         from './copy.component';
import {SchemaResolver}              from '../shared/resolvers/schemas.resolver';
import {ContactMomentsResolver}      from '../shared/resolvers/contact-moments.resolver';

const routes: Routes = [
    {
        path : 'schemas/overview',
        component : SchemasComponent,
        canActivate : [AuthenticationService],
        resolve: {
            bases: BasesResolver
        },
        data : {
            type: Base.TYPE_CHATOMATIC
        }
    },
    {
        path : 'schemas/:baseId/add',
        component : AddSchemaComponent,
        resolve: {
            base: BaseResolver
        },
        data: {
            baseRouteIdentifier: 'baseId'
        },
        canActivate : [AuthenticationService]
    },
    {
        path : 'schemas/:baseId/edit/:id',
        component : EditSchemaComponent,
        resolve : {
            base: BaseResolver,
            schema: SchemaResolver,
            contactMoments: ContactMomentsResolver
        },
        data: {
            baseRouteIdentifier: 'baseId',
            schemaRouteIdentifier: 'id',
            schemaBaseIdentifier: 'baseId',
            contactMomentBaseIdentifier: 'baseId',
            contactMomentSchemaIdentifier: 'id'
        },
        canActivate : [AuthenticationService]
    },
    {
        path : 'schemas/:baseId/copy/:sourceBaseId/:id',
        component : CopySchemaComponent,
        resolve : {
            base: BaseResolver,
            schema: SchemaResolver,
            contactMoments: ContactMomentsResolver
        },
        data: {
            baseRouteIdentifier: 'baseId',
            schemaRouteIdentifier: 'id',
            schemaBaseIdentifier: 'sourceBaseId',
            contactMomentBaseIdentifier: 'sourceBaseId',
            contactMomentSchemaIdentifier: 'id'
        },
        canActivate : [AuthenticationService]
    }
];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/schemas.routing.ts